import React, { Component } from 'react';
import { connect } from 'shalala';

import { Http } from '../../../support';
import { useStore } from '../../../store';
import LoadingButton from '../../../facturotopia/LoadingButton';

class HitsUsageDownload extends Component {
  state = {
    busy: false,
  };

  handleOnDownload = async () => {
    const { filters } = this.props.hitsUsage;

    this.setState({
      busy: true,
    });

    const params = {
      download: 1,
      limit: filters.limit,
      from: filters.from,
      to: filters.to,
    };

    try {
      const headers = {};

      const response = await Http.get(`${window.BONJOUR_URL}/app/empresas/hits`, {
        params,
        responseType: 'blob',
        headers,
      });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo',
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  render() {
    const { busy } = this.state;

    return (
      <LoadingButton
        variant="secondary"
        loading={busy}
        onClick={this.handleOnDownload.bind(this)}
      >
        {busy === true ? 'Descargando' : 'Descargar'}
      </LoadingButton>
    );
  }
}

const mapState = (store) => {
  return { hitsUsage: store.app.reports.hitsUsage };
};

const mapActions = (actions) => {
  return { hitsUsageActions: actions.app.reports.hitsUsage };
};

export default connect(useStore, mapState, mapActions)(HitsUsageDownload);
